import { useMemo } from 'react';

import { useStoreState } from '~/store/hooks';

interface IResult {
  alertMessage: string | null;
  noteMessage: string | null;
}

const useClientAvailabilityMessages = (clientId: number, memberId: number): IResult => {
  const { dateAvailability } = useStoreState(state => state.clientAllocation);

  const alertMessage = useMemo(() => {
    if (!dateAvailability?.isValid) {
      const match = dateAvailability?.clients.find(
        client =>
          client.clientId === clientId && !client.isDifferentUser && client.userId === memberId,
      );
      if (match) {
        return `Alert: client is already allocated to this user for this date${
          match.isDifferentTeam ? ' on another team' : ''
        }. Please remove in order to save.`;
      }
    }
    return null;
  }, [dateAvailability, clientId, memberId]);

  const noteMessage = useMemo(() => {
    if (!dateAvailability?.isValid) {
      const match = dateAvailability?.clients.find(
        client =>
          client.clientId === clientId && client.isDifferentUser && client.userId === memberId,
      );
      if (match) {
        return `Note: this client is allocated on this date${
          match.isDifferentTeam ? ' for another team.' : '.'
        }`;
      }
    }
    return null;
  }, [dateAvailability, clientId, memberId]);

  return { alertMessage, noteMessage };
};

export default useClientAvailabilityMessages;
